var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M111.713,467.478C152.797,495.563,202.477,512,256,512s103.202-16.437,144.287-44.522L256,445.217 L111.713,467.478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M400.287,44.522C359.202,16.437,309.523,0,256,0S152.797,16.437,111.713,44.522L256,66.783 L400.287,44.522z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M512,256c0-84.71-50.716-169.78-111.713-211.478H111.713C44.27,90.626,0,168.14,0,256 c0,87.863,44.27,165.374,111.713,211.478h288.574C467.731,421.374,512,343.863,512,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M241.513,417.597c-3.498-3-85.687-74.448-85.687-161.597s82.188-158.598,85.687-161.597L256,81.985 l14.487,12.417c3.498,3,85.687,74.448,85.687,161.598s-82.188,158.599-85.687,161.597L256,430.015L241.513,417.597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#338AF3"
    },
    d: "M333.913,256c0-77.913-77.913-144.696-77.913-144.696S178.087,178.089,178.087,256 c0,23.835,7.297,46.624,17.419,66.783h120.988C326.616,302.624,333.913,279.835,333.913,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M333.913,256c0,23.835-7.297,46.624-17.419,66.783L256,333.913l-60.494-11.13 c-10.122-20.158-17.419-42.948-17.419-66.783H333.913z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M256,400.696c0,0,37.528-32.177,60.494-77.913H195.506C218.472,368.519,256,400.696,256,400.696z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6DA544"
    },
    points: "205.913,211.478 306.087,211.478 256,261.565 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.304,
    y: 244.87,
    style: {
      fill: "#A2001D"
    },
    width: 33.391,
    height: 100.174
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGu);
export default __webpack_public_path__ + "static/media/gu.0dbc7dc94499edadae80d349426fa37f.svg";
export { ForwardRef as ReactComponent };